const THEME_STORAGE_KEY = 'ag_platform_theme';
const THEMES = new Set(['light', 'dark']);

export function normalizeTheme(theme) {
  return THEMES.has(theme) ? theme : 'light';
}

export function getStoredTheme() {
  if (typeof window === 'undefined') return 'light';
  try {
    return normalizeTheme(window.localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    return 'light';
  }
}

export function applyTheme(theme) {
  const normalized = normalizeTheme(theme);
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.theme = normalized;
  }
  return normalized;
}

export function setStoredTheme(theme) {
  const normalized = applyTheme(theme);
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, normalized);
    } catch {
      // Тема уже применена к документу; сохранение может быть недоступно в браузере.
    }
  }
  return normalized;
}

export function applyStoredTheme() {
  return applyTheme(getStoredTheme());
}
